import { useEffect, useState } from 'react';
import { Spinner } from '../components';
import { captureException } from '../lib/sentry';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import { globalMessages } from '../lib/messages';
import { useStripe } from '../lib/useStripe';

async function redirect(stripe: Stripe, sessionId: string) {
  const { error } = await stripe.redirectToCheckout({
    sessionId
  });
  if (error) {
    throw error;
  }
}

export const StripeCheckoutRedirect = ({
  sessionId,
  publishableKey,
  stripeScriptTimeout = 3000,
  showSpinner = true
}: {
  sessionId: string | null;
  publishableKey: string;
  stripeScriptTimeout?: number;
  showSpinner?: boolean;
}) => {
  const [redirecting, setRedirecting] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const { query, pathname } = useRouter();

  const { stripe, error: stripeError, loadStripeJs } = useStripe({
    publishableKey,
    timeout: stripeScriptTimeout
  });

  useEffect(() => {
    if (redirecting || !sessionId || !stripe) {
      return;
    }
    setRedirecting(true);
    redirect(stripe, sessionId).catch(err => {
      captureException(err, { query, pathname });
      setPaymentError(true);
    });
  }, [sessionId, stripe, pathname, query, redirecting]);

  return (
    <>
      {loadStripeJs}
      {paymentError && <FormattedMessage {...globalMessages.genericError} />}
      {stripeError}
      {!paymentError && !stripeError && showSpinner && (
        <div aria-label="Loading">
          <Spinner size={48} />
        </div>
      )}
    </>
  );
};
